import { CvApiWalletProvider } from "src/core/wallet/wallet.model";
import config from "src/config";

export function getLoginUrl(provider: CvApiWalletProvider): string {
    return `${config.apiHost}/auth/v2/${provider?.toLowerCase()}/login?redirectUrl=${document.URL}`;
}